module.exports = __webpack_public_path__ + "next.12b04fc756ca6ddd24e1731c4820a2e8.svg";


//////////////////
// WEBPACK FOOTER
// ./web_modules/trustar/img/next.svg
// module id = 1652
// module chunks = 39